var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgCookies = function SvgCookies(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1211 2C11.8443 3.39784 10.6562 4.4681 9.2002 4.56973C9.46738 5.54716 9.31306 6.68249 8.68556 7.66677C8.03843 8.68192 7.03214 9.31007 5.99841 9.45913C6.01247 9.58043 6.01995 9.70376 6.01995 9.82883C6.01995 11.5976 4.58311 13.0315 2.81064 13.0315C2.53057 13.0315 2.25898 12.9955 2 12.9283C2.46986 18.0159 6.75753 22 11.9783 22C17.5131 22 22 17.5224 22 11.9991C22 6.52339 17.59 2.07631 12.1211 2Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 7.5C18 8.32844 17.3284 9 16.5 9C15.6716 9 15 8.32844 15 7.5C15 6.67159 15.6716 6 16.5 6C17.3284 6 18 6.67159 18 7.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16.5C11 17.3284 10.3285 18 9.50003 18C8.67157 18 8.00003 17.3284 8.00003 16.5C8.00003 15.6716 8.67157 15 9.50003 15C10.3285 15 11 15.6716 11 16.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 15.5C18 16.3284 17.3285 17 16.5 17C15.6715 17 15 16.3284 15 15.5C15 14.6716 15.6715 14 16.5 14C17.3285 14 18 14.6716 18 15.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11C14 12.1046 13.1046 13 12 13C10.8954 13 10 12.1046 10 11C10 9.89544 10.8954 9 12 9C13.1046 9 14 9.89544 14 11Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5C6 6.10458 5.10458 7 3.99995 7C2.89542 7 2 6.10458 2 5C2 3.89542 2.89542 3 3.99995 3C5.10458 3 6 3.89542 6 5Z",
    fill: "white"
  })));
};
export default SvgCookies;